module.exports = __webpack_public_path__ + "img/194.a134e6af.jpg";